module.exports = __webpack_public_path__ + "img/museum.e0cbe425.svg";